<template>
  <div class="option-summary-box">
    <div class="option-summary__row">
      <p class="small-regular gray-900" >
        Entrada <span v-if="downPaymentPercentage!==0">({{  downPaymentPercentage + '%' }})</span>
      </p>
      <p
        :class="{ skeleton: loadingDownPayment }"
        class="option-result gray-900"
        v-if="downPaymentValue > 0"
      >
        {{ downPaymentValue | moneyFilter }}
      </p>
      <p v-else class="small-regular gray-900"> - </p>
    </div>

    <div class="option-summary__row">
      <p class="small-regular gray-900">Parcelas</p>
      <p
        v-if="!installmentAmount || !installmentValue"
        class="small-regular gray-900"
      >
        -
      </p>
      <p
        v-else
        class="option-result gray-900"
        :class="{ skeleton: loadingInstallments }"
      >
        {{ installmentAmount }}x de {{ installmentValue | moneyFilter }}
      </p>
    </div>

    <div class="option-summary__row">
      <p class="small-regular gray-900">Valor total</p>
      <p class="option-result gray-900"  :class="{ skeleton: loadingSummary }">
        {{ totalAmount | moneyFilter }}
      </p>
    </div>

    <div class="option-summary__extra-info">
      <p class="x-small-regular gray-500">
        Juros de {{ interestRatePM | interestRateFilter }} a.m. + encargos
        <br>
        CET máximo de {{ cetPA | interestRateFilter }} a.a.
      </p>
    </div>
  </div>
</template>

<script>
import StringMixin from '@/mixins/string';

export default {
  name: 'OptionSummary',
  mixins: [StringMixin],
  props: {
    downPaymentPercentage: {
      type: Number,
      required: false,
    },
    downPaymentValue: {
      type: Number,
      required: false,
    },
    totalAmount: {
      type: Number,
      required: false,
    },
    installmentAmount: {
      type: Number,
      required: false,
    },
    installmentValue: {
      type: Number,
      required: false,
    },
    interestRatePM: {
      type: Number,
      required: false,
    },
    cetPA: {
      type: Number,
      required: false,
    },
    loadingInstallments: {
      type: Boolean,
      required: false,
    },
    loadingSummary: {
      type: Boolean,
      required: false,
    },
    loadingDownPayment: {
      type: Boolean,
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../scss/__new-styles.scss';

  .option-summary-box {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;
    border-radius: 6px;
    background-color: $gray-100;
  }

  .option-summary__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .option-summary__extra-info {
    margin-top: 4px;
    display: flex;
    justify-content: flex-end;
    text-align: right;

    p {
      width: 85%;
    }
  }
  .option-result {
    font-size: 16px;
    line-height: 24px;
    font-weight: bold;
  }

</style>
